import axios from 'axios';
import { api } from '../../../network';

type ImageVisibility = 'public' | 'private';

const CF_IMAGE_ENDPOINT = 'https://imagedelivery.net/';

export const uploadImage = async (
	file: string | Blob,
	visibility: ImageVisibility
) => {
	try {
		const response = await axios.post(`${api()}image/upload/`, { visibility });
		const {
			result: { uploadURL },
		} = response.data;

		const formData = new FormData();
		formData.append('file', file);

		const result = await axios.post(uploadURL, formData);

		return result.data.result.variants?.[0];
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Error uploading image:', error);
		throw error;
	}
};

export const proxyImageThroughLocalAPI = (variant: string) => {
	const path = variant.replace(CF_IMAGE_ENDPOINT, '');
	return `/api/v1/image/${path}/`;
};

export const uploadImagePrivate = async (file: string | Blob) => {
	try {
		const variant = await uploadImage(file, 'private');
		return proxyImageThroughLocalAPI(variant);
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Error uploading private image:', error);
		throw error;
	}
};

export const uploadImagePublic = async (file: string | Blob) => {
	try {
		const variant = await uploadImage(file, 'public');
		return variant;
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Error uploading public image:', error);
		throw error;
	}
};
